<div class="page-container">
  <app-page-title [titleKey]="'carnet.title'"></app-page-title>

  <app-children-selector (studentSelected)="onStudentSelected($event)" (studentsLoaded)="onStudentsLoaded($event)"></app-children-selector>
<app-loader [isLoading]="isLoading"></app-loader>

  <!-- Loading and Error States -->
  <div *ngIf="loading" class="text-center py-8">
    <p class="text-gray-600">{{ 'carnet.loading' | translate }}</p>
  </div>
  
  <div *ngIf="error" class="text-center py-8">
    <p class="text-red-600">{{ 'carnet.error' | translate }}</p>
  </div>

  <!-- Grid of four permanent rectangles -->
  <div class="grid" *ngIf="!loading && !error">
    <!-- Premiere Trimestre -->
    <section class="card">
      <div class="card-header">{{ 'carnet.trimesters.premiere' | translate }}</div>
      <div class="card-body">
        <div class="row">
          <ng-container *ngIf="digiref !== null && digiref <= 6">
            <button class="pill" [class.disabled]="!hasCarnetType('premiere', 'carnet_prive')">
              carnet privée
              <span class="actions">
                <i class="pi pi-eye icon" (click)="hasCarnetType('premiere', 'carnet_prive') ? openModal(getCarnetByType('premiere', 'carnet_prive')!) : null"></i>
                <i class="pi pi-download icon" (click)="getFirstFileFromCarnet(getCarnetByType('premiere', 'carnet_prive')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('premiere', 'carnet_prive'))!) : null"></i>
              </span>
            </button>
            <button class="pill" [class.disabled]="!hasCarnetType('premiere', 'carnet_etatique')">
              carnet étatique
              <span class="actions">
                <i class="pi pi-eye icon" (click)="hasCarnetType('premiere', 'carnet_etatique') ? openModal(getCarnetByType('premiere', 'carnet_etatique')!) : null"></i>
                <i class="pi pi-download icon" (click)="getFirstFileFromCarnet(getCarnetByType('premiere', 'carnet_etatique')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('premiere', 'carnet_etatique'))!) : null"></i>
              </span>
            </button>
          </ng-container>
          <ng-container *ngIf="digiref !== null && digiref >= 7">
            <button class="pill" [class.disabled]="!hasCarnetType('premiere', 'bulletin')">
              bulletin
              <span class="actions">
                <i class="pi pi-download icon" (click)="getFirstFileFromCarnet(getCarnetByType('premiere', 'bulletin')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('premiere', 'bulletin'))!) : null"></i>
              </span>
            </button>
          </ng-container>
        </div>
        <div class="row">
          <ng-container *ngIf="digiref !== null && digiref <= 6">
            <button class="pill" [class.disabled]="!hasCarnetType('premiere', 'certificat_prive')">
              certificat privée
              <span class="actions">
                <i class="pi pi-eye icon" (click)="hasCarnetType('premiere', 'certificat_prive') ? openModal(getCarnetByType('premiere', 'certificat_prive')!) : null"></i>
                <i class="pi pi-download icon" (click)="getFirstFileFromCarnet(getCarnetByType('premiere', 'certificat_prive')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('premiere', 'certificat_prive'))!) : null"></i>
              </span>
            </button>
            <button class="pill" [class.disabled]="!hasCarnetType('premiere', 'certificat_etatique')">
              certificat étatique
              <span class="actions">
                <i class="pi pi-eye icon" (click)="hasCarnetType('premiere', 'certificat_etatique') ? openModal(getCarnetByType('premiere', 'certificat_etatique')!) : null"></i>
                <i class="pi pi-download icon" (click)="getFirstFileFromCarnet(getCarnetByType('premiere', 'certificat_etatique')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('premiere', 'certificat_etatique'))!) : null"></i>
              </span>
            </button>
          </ng-container>
          <ng-container *ngIf="digiref !== null && digiref >= 7">
            <button class="pill" [class.disabled]="!hasCarnetType('premiere', 'certificat_prive') && !hasCarnetType('premiere', 'certificat_etatique')">
              certificat
              <span class="actions">
                <i class="pi pi-download icon" (click)="getFirstFileFromCarnet(getCarnetByType('premiere', 'certificat_prive')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('premiere', 'certificat_prive'))!) : (getFirstFileFromCarnet(getCarnetByType('premiere', 'certificat_etatique')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('premiere', 'certificat_etatique'))!) : null)"></i>
              </span>
            </button>
          </ng-container>
        </div>
      </div>
    </section>

    <!-- Deuxième Trimestre -->
    <section class="card">
      <div class="card-header">{{ 'carnet.trimesters.deuxieme' | translate }}</div>
      <div class="card-body">
        <div class="row">
          <ng-container *ngIf="digiref !== null && digiref <= 6">
            <button class="pill" [class.disabled]="!hasCarnetType('deuxieme', 'carnet_prive')">
              carnet privée
              <span class="actions">
                <i class="pi pi-eye icon" (click)="hasCarnetType('deuxieme', 'carnet_prive') ? openModal(getCarnetByType('deuxieme', 'carnet_prive')!) : null"></i>
                <i class="pi pi-download icon" (click)="getFirstFileFromCarnet(getCarnetByType('deuxieme', 'carnet_prive')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('deuxieme', 'carnet_prive'))!) : null"></i>
              </span>
            </button>
            <button class="pill" [class.disabled]="!hasCarnetType('deuxieme', 'carnet_etatique')">
              carnet étatique
              <span class="actions">
                <i class="pi pi-eye icon" (click)="hasCarnetType('deuxieme', 'carnet_etatique') ? openModal(getCarnetByType('deuxieme', 'carnet_etatique')!) : null"></i>
                <i class="pi pi-download icon" (click)="getFirstFileFromCarnet(getCarnetByType('deuxieme', 'carnet_etatique')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('deuxieme', 'carnet_etatique'))!) : null"></i>
              </span>
            </button>
          </ng-container>
          <ng-container *ngIf="digiref !== null && digiref >= 7">
            <button class="pill" [class.disabled]="!hasCarnetType('deuxieme', 'bulletin')">
              bulletin
              <span class="actions">
                <i class="pi pi-download icon" (click)="getFirstFileFromCarnet(getCarnetByType('deuxieme', 'bulletin')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('deuxieme', 'bulletin'))!) : null"></i>
              </span>
            </button>
          </ng-container>
        </div>
        <div class="row">
          <ng-container *ngIf="digiref !== null && digiref <= 6">
            <button class="pill" [class.disabled]="!hasCarnetType('deuxieme', 'certificat_prive')">
              certificat privée
              <span class="actions">
                <i class="pi pi-eye icon" (click)="hasCarnetType('deuxieme', 'certificat_prive') ? openModal(getCarnetByType('deuxieme', 'certificat_prive')!) : null"></i>
                <i class="pi pi-download icon" (click)="getFirstFileFromCarnet(getCarnetByType('deuxieme', 'certificat_prive')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('deuxieme', 'certificat_prive'))!) : null"></i>
              </span>
            </button>
            <button class="pill" [class.disabled]="!hasCarnetType('deuxieme', 'certificat_etatique')">
              certificat étatique
              <span class="actions">
                <i class="pi pi-eye icon" (click)="hasCarnetType('deuxieme', 'certificat_etatique') ? openModal(getCarnetByType('deuxieme', 'certificat_etatique')!) : null"></i>
                <i class="pi pi-download icon" (click)="getFirstFileFromCarnet(getCarnetByType('deuxieme', 'certificat_etatique')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('deuxieme', 'certificat_etatique'))!) : null"></i>
              </span>
            </button>
          </ng-container>
          <ng-container *ngIf="digiref !== null && digiref >= 7">
            <button class="pill" [class.disabled]="!hasCarnetType('deuxieme', 'certificat_prive') && !hasCarnetType('deuxieme', 'certificat_etatique')">
              certificat
              <span class="actions">
                <i class="pi pi-download icon" (click)="getFirstFileFromCarnet(getCarnetByType('deuxieme', 'certificat_prive')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('deuxieme', 'certificat_prive'))!) : (getFirstFileFromCarnet(getCarnetByType('deuxieme', 'certificat_etatique')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('deuxieme', 'certificat_etatique'))!) : null)"></i>
              </span>
            </button>
          </ng-container>
        </div>
      </div>
    </section>

    <!-- Troisième Trimestre -->
    <section class="card">
      <div class="card-header">{{ 'carnet.trimesters.troisieme' | translate }}</div>
      <div class="card-body">
        <div class="row">
          <ng-container *ngIf="digiref !== null && digiref <= 6">
            <button class="pill" [class.disabled]="!hasCarnetType('troisieme', 'carnet_prive')">
              carnet privée
              <span class="actions">
                <i class="pi pi-eye icon" (click)="hasCarnetType('troisieme', 'carnet_prive') ? openModal(getCarnetByType('troisieme', 'carnet_prive')!) : null"></i>
                <i class="pi pi-download icon" (click)="getFirstFileFromCarnet(getCarnetByType('troisieme', 'carnet_prive')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('troisieme', 'carnet_prive'))!) : null"></i>
              </span>
            </button>
            <button class="pill" [class.disabled]="!hasCarnetType('troisieme', 'carnet_etatique')">
              carnet étatique
              <span class="actions">
                <i class="pi pi-eye icon" (click)="hasCarnetType('troisieme', 'carnet_etatique') ? openModal(getCarnetByType('troisieme', 'carnet_etatique')!) : null"></i>
                <i class="pi pi-download icon" (click)="getFirstFileFromCarnet(getCarnetByType('troisieme', 'carnet_etatique')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('troisieme', 'carnet_etatique'))!) : null"></i>
              </span>
            </button>
          </ng-container>
          <ng-container *ngIf="digiref !== null && digiref >= 7">
            <button class="pill" [class.disabled]="!hasCarnetType('troisieme', 'bulletin')">
              bulletin
              <span class="actions">
                <i class="pi pi-download icon" (click)="getFirstFileFromCarnet(getCarnetByType('troisieme', 'bulletin')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('troisieme', 'bulletin'))!) : null"></i>
              </span>
            </button>
          </ng-container>
        </div>
        <div class="row">
          <ng-container *ngIf="digiref !== null && digiref <= 6">
            <button class="pill" [class.disabled]="!hasCarnetType('troisieme', 'certificat_prive')">
              certificat privée
              <span class="actions">
                <i class="pi pi-eye icon" (click)="hasCarnetType('troisieme', 'certificat_prive') ? openModal(getCarnetByType('troisieme', 'certificat_prive')!) : null"></i>
                <i class="pi pi-download icon" (click)="getFirstFileFromCarnet(getCarnetByType('troisieme', 'certificat_prive')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('troisieme', 'certificat_prive'))!) : null"></i>
              </span>
            </button>
            <button class="pill" [class.disabled]="!hasCarnetType('troisieme', 'certificat_etatique')">
              certificat étatique
              <span class="actions">
                <i class="pi pi-eye icon" (click)="hasCarnetType('troisieme', 'certificat_etatique') ? openModal(getCarnetByType('troisieme', 'certificat_etatique')!) : null"></i>
                <i class="pi pi-download icon" (click)="getFirstFileFromCarnet(getCarnetByType('troisieme', 'certificat_etatique')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('troisieme', 'certificat_etatique'))!) : null"></i>
              </span>
            </button>
          </ng-container>
          <ng-container *ngIf="digiref !== null && digiref >= 7">
            <button class="pill" [class.disabled]="!hasCarnetType('troisieme', 'certificat_prive') && !hasCarnetType('troisieme', 'certificat_etatique')">
              certificat
              <span class="actions">
                <i class="pi pi-download icon" (click)="getFirstFileFromCarnet(getCarnetByType('troisieme', 'certificat_prive')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('troisieme', 'certificat_prive'))!) : (getFirstFileFromCarnet(getCarnetByType('troisieme', 'certificat_etatique')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('troisieme', 'certificat_etatique'))!) : null)"></i>
              </span>
            </button>
          </ng-container>
        </div>
      </div>
    </section>

    <!-- Annexe -->
    <section class="card">
      <div class="card-header">{{ 'carnet.trimesters.annexe' | translate }}</div>
      <div class="card-body">
        <div class="row">
          <ng-container *ngIf="digiref !== null && digiref < 7">
            <button class="pill" [class.disabled]="!hasCarnetType('annexe', 'annexe_prive')">
              annexe privée
              <span class="actions">
                <i class="pi pi-eye icon" (click)="hasCarnetType('annexe', 'annexe_prive') ? openModal(getCarnetByType('annexe', 'annexe_prive')!) : null"></i>
                <i class="pi pi-download icon" (click)="getFirstFileFromCarnet(getCarnetByType('annexe', 'annexe_prive')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('annexe', 'annexe_prive'))!) : null"></i>
              </span>
            </button>
            <button class="pill" [class.disabled]="!hasCarnetType('annexe', 'annexe_etatique')">
              annexe étatique
              <span class="actions">
                <i class="pi pi-eye icon" (click)="hasCarnetType('annexe', 'annexe_etatique') ? openModal(getCarnetByType('annexe', 'annexe_etatique')!) : null"></i>
                <i class="pi pi-download icon" (click)="getFirstFileFromCarnet(getCarnetByType('annexe', 'annexe_etatique')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('annexe', 'annexe_etatique'))!) : null"></i>
              </span>
            </button>
          </ng-container>
          <ng-container *ngIf="digiref !== null && digiref >= 7">
            <button class="pill" [class.disabled]="!hasCarnetType('annexe', 'annexe_prive') && !hasCarnetType('annexe', 'annexe_etatique')">
              annexe
              <span class="actions">
                <i class="pi pi-eye icon" (click)="hasCarnetType('annexe', 'annexe_prive') ? openModal(getCarnetByType('annexe', 'annexe_prive')!) : (hasCarnetType('annexe', 'annexe_etatique') ? openModal(getCarnetByType('annexe', 'annexe_etatique')!) : null)"></i>
                <i class="pi pi-download icon" (click)="getFirstFileFromCarnet(getCarnetByType('annexe', 'annexe_prive')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('annexe', 'annexe_prive'))!) : (getFirstFileFromCarnet(getCarnetByType('annexe', 'annexe_etatique')) ? downloadFile(getFirstFileFromCarnet(getCarnetByType('annexe', 'annexe_etatique'))!) : null)"></i>
              </span>
            </button>
          </ng-container>
        </div>
      </div>
    </section>
  </div>
</div>

<!-- Modal -->
<div class="carnet-modal-backdrop" *ngIf="showModal" (click)="closeModal()"></div>
<div class="carnet-modal" *ngIf="showModal">
  <div class="carnet-modal__header">
    <h3>{{ getModalTitle(modalItem) }}</h3>
    <button class="close" (click)="closeModal()" [attr.aria-label]="'carnet.modal.close' | translate">×</button>
  </div>
  <div class="carnet-modal__body">
    <div *ngIf="modalLoading" class="carnet-modal__state">{{ 'carnet.loading' | translate }}</div>
    <div *ngIf="!modalLoading && modalError" class="carnet-modal__state carnet-modal__state--error">{{ modalError }}</div>
    <div *ngIf="!modalLoading && !modalError && modalHtml" class="carnet-modal__content" [innerHTML]="modalHtml"></div>
    <p *ngIf="!modalLoading && !modalError && !modalHtml" class="carnet-modal__state">{{ 'carnet.modal.noContent' | translate }}</p>
    <div *ngIf="modalItem?.files?.length" class="carnet-modal__files">
      <div class="carnet-modal__file" *ngFor="let f of modalItem?.files">
        <span class="carnet-modal__file-name">{{ getModalTitle(modalItem) }}</span>
        <button class="carnet-modal__download" (click)="downloadFile(f.path)">{{ 'carnet.modal.downloadFile' | translate }}</button>
      </div>
    </div>
  </div>
</div>